import { Avatar, Header } from "@pentabd/ui";
import { HeaderProps } from "@pentabd/ui/build/atoms/header/Header";

import { EmployeeCommonInfoType } from "@type/HRM/employee-common-info";
import { GetEmployeeDetails } from "@utils/getEmployeeDetails";

interface EmployeeHeaderProps extends HeaderProps {
  employee: EmployeeCommonInfoType;
}

export const EmployeeHeader = ({
  employee,
  breadcrumbs,
  actions,
  className,
  size,
  noBorder,
}: EmployeeHeaderProps) => {
  const { employeeName, employeePosition, employeeImage } =
    GetEmployeeDetails(employee);

  return (
    <Header
      breadcrumbs={breadcrumbs}
      headerText={{
        header: employeeName,
        subHeader: employeePosition,
      }}
      avatar={<Avatar size="xm" name={employeeName} imageURL={employeeImage} />}
      noBorder={noBorder}
      className={className}
      actions={actions}
      size={size}
    />
  );
};
